import DataHelpers from './DataHelpers'
import NiceData from '../data/NiceData'

export default class {


    //Adapted from https://stackoverflow.com/questions/27908312/can-you-get-the-timestamp-from-a-firebase-array-key   
    static pushKeyToDateString(id) {
        const PUSH_CHARS = "-0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ_abcdefghijklmnopqrstuvwxyz"
        id = id.substring(0,8)
        var timestamp = 0
        for (var i=0; i < id.length; i++) {
            var c = id.charAt(i)
            timestamp = timestamp * 64 + PUSH_CHARS.indexOf(c)
        }
        return timestamp
    }

    
    static snapshotToArray  (snapshot, reverse) {
        let returnArr = []

        snapshot.forEach(childSnapshot => {
            let item = childSnapshot.val(); 
            item['.key'] = childSnapshot.key    //to remove later
            item.key = childSnapshot.key
            if(reverse)
                returnArr.unshift(item)
            else
                returnArr.push(item)
        })

        return returnArr
    }

    static snapshotToObject  (snapshot) {
        let objArray = this.snapshotToArray(snapshot)
        if(objArray.length > 0)
            return objArray[0]
        else
            return null
    }

    static arrayToFirebaseObject(array) {
        let obj = {}
        array.forEach( (item) => {
            let key = item['key'] || item['.key']
            let newItem = this.cloneWithoutKey(item)
            obj[key] = newItem
        })
        return obj
    }

    static snapItemToObject (snap) {
        
        // returns an object with an item of interest and a key

        let obj = {item: {}, key: snap.key}
        for(let fld in snap.val()) {
            if(!fld.startsWith('_')) {
                obj.item[fld] = snap.val()[fld]
            }
        }
        return obj
    }

    static snapToObject (snap) {
        
        // returns an object with an item of interest and a key

        let obj = {key: snap.key}
        for(let fld in snap.val()) {
            if(!fld.startsWith('_')) {
                obj[fld] = snap.val()[fld]
            }
        }
        return obj
    }

    static snapshotPushArray  (snapshot, array) {
        if(!array)
            console.error('snapshotPushArray > No array passed')

        snapshot.forEach(childSnapshot => {
            let item = childSnapshot.val()
            item['.key'] = childSnapshot.key
            item.key = childSnapshot.key
            array.push(item)
        });
    }

    static cloneWithoutKey(item) {

        let returnItem = JSON.parse(JSON.stringify(item))
        delete returnItem['.key']
        delete returnItem['key']
        delete returnItem['meta']
        return returnItem
    }

    static firebaseConsolePathFromRefString(str) {
        return this.firebaseConsolePath() + '/' + this.firebasePathFromRefString(str)
    }

    static firebasePathFromRefString(str) {
        if(!str) {
            console.error('No string passed to FirebaseHelpers > firebasePathFromRefString')
            return ''
        }
            
        return str.replace('https://photon-6d209.firebaseio.com/', '')
    }


    static firebaseConsolePath() {
        return 'https://console.firebase.google.com/u/0/project/photon-6d209/database/photon-6d209/data'
    }

    static viewInConsole (pathString) {
        pathString = this.firebaseConsolePath() + '/' + pathString
        window.open(pathString, '_blank')
    }

    static saveToFirebase(obj, ref) {
    
        if(!obj) {
            console.log('saveToFirebase - Nothing to save')
            return
        }

        if(obj.delete) {
            ref.child(obj.key).remove()
            return
        }
        
        let newElement = Object.assign({}, obj)
        let key = newElement.key || newElement['.key'] || DataHelpers.getKey()
        newElement.stamp = DataHelpers.getStamp()
        //this.updateObjectArray(newElement, arr)
        delete newElement['key']
        delete newElement['.key']
        delete newElement['selected']
        console.log('saveToFirebase - Saving', newElement, ref.toString())
        ref.child(key).update(newElement)
    }

    static deleteFromFirebase(obj, ref) {
    
        if(!obj) {
            console.log('x  rebase - Nothing to delete')
            return
        }
        console.log('deleting from firebase', ref.toString())
        

        ref.child(obj.key || obj.meta.key).remove()    
    }

    static copyItem(fromRef, toRef, itemKey, preserveKey = false) {
        return new Promise( (resolve, reject) => {
            fromRef.child(itemKey).once( snap => {
                let item = snap.val() 
                if(!item)
                    reject('copyItem could not find the item to copy')
                const key = (preserveKey ? snap.key : DataHelpers.getKey)
                toRef.child(key).set(item)
      
                resolve(item)
            })
        })
    }


}


// WEBPACK FOOTER //
// ./src/helpers/FirebaseHelpers.js